module.exports = __webpack_public_path__ + "img/logo.1e020584.svg";